import { call, put, takeEvery } from "redux-saga/effects";
import * as actions from "actions/location";
import { apiGet, apiPost, apiDelete, apiPut } from "sagas/callApi";

function* fetchAll(api) {
  try {
    const resp = yield call(apiGet, api, `/location`, null, true);
    yield put(actions.fetchAllSuccess(resp.data));
  } catch (e) {
    yield put(actions.fetchAllFailed(e));
  }
}

function* createOne(api, { payload, meta }) {
  try {
    const { data } = payload;
    const resp = yield call(apiPost, api, `/location`, data, true);
    yield put(actions.createOneSuccess(resp.data, meta));
  } catch (e) {
    yield put(actions.createOneFailed(e, meta));
  }
}

function* deleteOne(api, { payload, meta }) {
  try {
    const { id } = payload;
    yield call(apiDelete, api, `/location/${id}`, null, true);
    yield put(actions.deleteOneSuccess(id, meta));
  } catch (e) {
    yield put(actions.deleteOneFailed(e.response.data.error, meta));
  }
}

function* updateOne(api, { payload, meta }) {
  try {
    const { data, id } = payload;
    const resp = yield call(apiPut, api, `/location/${id}`, data, true);
    yield put(actions.updateOneSuccess(resp.data, meta));
  } catch (e) {
    yield put(actions.updateOneFailed(e, meta));
  }
}

export default function* rootSaga({ api }) {
  yield takeEvery(actions.DELETE_ONE, deleteOne, api);
  yield takeEvery(actions.CREATE_ONE, createOne, api);
  yield takeEvery(actions.FETCH_ALL, fetchAll, api);
  yield takeEvery(actions.UPDATE_ONE, updateOne, api);
}



// WEBPACK FOOTER //
// ./src/sagas/location.js